import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, FileCodeIcon, ShieldCheckIcon, AlertCircleIcon, ArrowRightIcon, TerminalIcon, MapIcon, ServerIcon } from 'lucide-react';
import { StatusBadge } from '../components/ui/StatusBadge';
import { Terminal } from '../components/ui/Terminal';
export function DashboardPage() {
  const terminalCommands = [{
    input: 'npx paykit status',
    output: ['✔ Environment: Next.js + Node.js', '✔ Stripe Connection: Active', '✔ Webhooks: 6 events subscribed']
  }];
  return <div className="flex flex-col pb-12" data-id="element-467">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4" data-id="element-468">
        <div data-id="element-469">
          <h1 className="text-3xl font-bold mb-1" data-id="element-470">Welcome back, Alex</h1>
          <p className="text-muted-foreground" data-id="element-471">
            {new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
        <div className="flex gap-3" data-id="element-472">
          <Link to="/setup" className="bg-primary text-primary-foreground hover:opacity-90 px-4 py-2 rounded-md text-sm font-medium transition-opacity flex items-center gap-2" data-id="element-473">
            <PlusIcon className="w-4 h-4" data-id="element-474" />
            New Setup
          </Link>
        </div>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-475">
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-476">
          <div className="text-sm font-medium text-muted-foreground mb-2" data-id="element-477">
            Total Setups
          </div>
          <div className="text-3xl font-bold" data-id="element-478">3</div>
        </div>
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-479">
          <div className="text-sm font-medium text-muted-foreground mb-2" data-id="element-480">
            Active Monitoring
          </div>
          <div className="text-3xl font-bold" data-id="element-481">1</div>
        </div>
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-482">
          <div className="text-sm font-medium text-muted-foreground mb-2" data-id="element-483">
            Alerts
          </div>
          <div className="text-3xl font-bold text-pk-amber" data-id="element-484">2</div>
        </div>
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-485">
          <div className="text-sm font-medium text-muted-foreground mb-2" data-id="element-486">
            Health Score
          </div>
          <div className="text-3xl font-bold text-pk-success" data-id="element-487">94%</div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-488">
        {/* Main Content - Recent Setups & Terminal */}
        <div className="md:col-span-2 space-y-6" data-id="element-489">
          <div className="bg-card border border-border rounded-xl shadow-sm p-6" data-id="element-490">
            <h2 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-491">
              <TerminalIcon className="w-5 h-5 text-muted-foreground" data-id="element-492" />
              Quick CLI Access
            </h2>
            <Terminal commands={terminalCommands} data-id="element-493" />
          </div>

          <div className="bg-card border border-border rounded-xl shadow-sm overflow-hidden" data-id="element-494">
            <div className="px-6 py-4 border-b border-border flex justify-between items-center" data-id="element-495">
              <h2 className="font-bold text-lg" data-id="element-496">Recent Setups</h2>
            </div>
            <div className="overflow-x-auto" data-id="element-497">
              <table className="w-full text-sm text-left" data-id="element-498">
                <thead className="text-xs text-muted-foreground uppercase bg-muted/50 border-b border-border" data-id="element-499">
                  <tr data-id="element-500">
                    <th className="px-6 py-3 font-medium" data-id="element-501">Name</th>
                    <th className="px-6 py-3 font-medium" data-id="element-502">Provider</th>
                    <th className="px-6 py-3 font-medium" data-id="element-503">Status</th>
                    <th className="px-6 py-3 font-medium text-right" data-id="element-504">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border" data-id="element-505">
                  <tr className="hover:bg-muted/30 transition-colors" data-id="element-506">
                    <td className="px-6 py-4 font-medium" data-id="element-507">Acme SaaS</td>
                    <td className="px-6 py-4 text-muted-foreground" data-id="element-508">Stripe</td>
                    <td className="px-6 py-4" data-id="element-509">
                      <StatusBadge status="success" label="Active" data-id="element-510" />
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-511">
                      <Link to="/setup/complete" className="text-primary hover:underline font-medium" data-id="element-512">
                        View Pack
                      </Link>
                    </td>
                  </tr>
                  <tr className="hover:bg-muted/30 transition-colors" data-id="element-513">
                    <td className="px-6 py-4 font-medium" data-id="element-514">Side Project</td>
                    <td className="px-6 py-4 text-muted-foreground" data-id="element-515">Stripe</td>
                    <td className="px-6 py-4" data-id="element-516">
                      <StatusBadge status="in-progress" label="Provisioning" data-id="element-517" />
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-518">
                      <Link to="/setup/progress" className="text-primary hover:underline font-medium" data-id="element-519">
                        Resume
                      </Link>
                    </td>
                  </tr>
                  <tr className="hover:bg-muted/30 transition-colors" data-id="element-520">
                    <td className="px-6 py-4 font-medium" data-id="element-521">Client App</td>
                    <td className="px-6 py-4 text-muted-foreground" data-id="element-522">Stripe</td>
                    <td className="px-6 py-4" data-id="element-523">
                      <StatusBadge status="pending" label="Draft" data-id="element-524" />
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-525">
                      <Link to="/setup" className="text-primary hover:underline font-medium" data-id="element-526">
                        Continue
                      </Link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Sidebar - Alerts & Connections */}
        <div className="space-y-6" data-id="element-527">
          <div className="bg-card border border-border rounded-xl shadow-sm p-6" data-id="element-528">
            <h2 className="font-bold text-lg mb-4" data-id="element-529">Quick Actions</h2>
            <div className="space-y-2" data-id="element-530">
              <Link to="/blueprint" className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors group" data-id="element-531">
                <div className="flex items-center gap-3" data-id="element-532">
                  <MapIcon className="w-4 h-4 text-primary" data-id="element-533" />
                  <span className="text-sm font-medium" data-id="element-534">View Blueprint</span>
                </div>
                <ArrowRightIcon className="w-4 h-4 text-muted-foreground group-hover:text-foreground transition-colors" data-id="element-535" />
              </Link>
              <Link to="/providers" className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors group" data-id="element-536">
                <div className="flex items-center gap-3" data-id="element-537">
                  <ServerIcon className="w-4 h-4 text-primary" data-id="element-538" />
                  <span className="text-sm font-medium" data-id="element-539">Manage Providers</span>
                </div>
                <ArrowRightIcon className="w-4 h-4 text-muted-foreground group-hover:text-foreground transition-colors" data-id="element-540" />
              </Link>
              <Link to="/setup/complete" className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors group" data-id="element-541">
                <div className="flex items-center gap-3" data-id="element-542">
                  <FileCodeIcon className="w-4 h-4 text-primary" data-id="element-543" />
                  <span className="text-sm font-medium" data-id="element-544">
                    Implementation Pack
                  </span>
                </div>
                <ArrowRightIcon className="w-4 h-4 text-muted-foreground group-hover:text-foreground transition-colors" data-id="element-545" />
              </Link>
            </div>
          </div>

          <div className="bg-card border border-border rounded-xl shadow-sm p-6" data-id="element-546">
            <h2 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-547">
              <AlertCircleIcon className="w-5 h-5 text-pk-amber" data-id="element-548" />
              Recent Alerts
            </h2>
            <div className="space-y-4" data-id="element-549">
              <div className="p-3 bg-pk-amber-light/30 border border-pk-amber/20 rounded-lg" data-id="element-550">
                <div className="text-sm font-medium text-pk-amber-dark mb-1" data-id="element-551">
                  Price modified directly in Stripe
                </div>
                <div className="text-xs text-muted-foreground" data-id="element-552">
                  Acme SaaS • 2 hours ago
                </div>
              </div>
              <div className="p-3 bg-pk-error-light/30 border border-pk-error/20 rounded-lg" data-id="element-553">
                <div className="text-sm font-medium text-pk-error mb-1" data-id="element-554">
                  Webhook delivery failed (500)
                </div>
                <div className="text-xs text-muted-foreground" data-id="element-555">
                  Acme SaaS • 5 hours ago
                </div>
              </div>
            </div>
            <Link to="/monitoring" className="block text-center text-sm text-primary font-medium mt-4 hover:underline" data-id="element-556">
              View all alerts
            </Link>
          </div>

          <div className="bg-card border border-border rounded-xl shadow-sm p-6" data-id="element-557">
            <h2 className="font-bold text-lg mb-4" data-id="element-558">Infrastructure Status</h2>
            <div className="space-y-4" data-id="element-559">
              <div className="flex items-center justify-between p-3 border border-border rounded-lg bg-pk-surface" data-id="element-560">
                <div className="flex items-center gap-3" data-id="element-561">
                  <div className="w-8 h-8 bg-[#635BFF] rounded flex items-center justify-center text-white font-bold text-xs" data-id="element-562">
                    S
                  </div>
                  <div data-id="element-563">
                    <div className="text-sm font-medium" data-id="element-564">Stripe Gateway</div>
                    <div className="text-xs text-muted-foreground" data-id="element-565">
                      acct_1N2M...
                    </div>
                  </div>
                </div>
                <StatusBadge status="success" label="Active" className="!bg-transparent !border-none !p-0" data-id="element-566" />
              </div>

              <div className="flex items-center justify-between p-3 border border-border rounded-lg bg-pk-surface" data-id="element-567">
                <div data-id="element-568">
                  <div className="text-sm font-medium" data-id="element-569">Webhook Endpoint</div>
                  <div className="text-xs text-muted-foreground" data-id="element-570">
                    Last sync: 2m ago
                  </div>
                </div>
                <StatusBadge status="success" label="Healthy" data-id="element-571" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}